import {
  BookingStepValueEnum,
  BookingSubStepValueEnum,
} from '../../components/BookingWidget/bookingSteps.interface';
import { BookingStepsContextState } from '../../context/bookingContext/bookingContext.types';
import {
  Product,
  ProductError,
} from '../interfaces/plugAndSell/createPricingResponse';

const updatePriceInBookingSteps = (
  bookingSteps: BookingStepsContextState,
  psProducts: (Product | ProductError)[],
): BookingStepsContextState => {
  const priceNet =
    'errorMessage' in psProducts[0]
      ? 0
      : (psProducts[0] as Product).totalPrice.netPrice;
  return {
    ...bookingSteps,
    [BookingStepValueEnum.QuotationProposals]: {
      ...bookingSteps[BookingStepValueEnum.QuotationProposals],
      [BookingSubStepValueEnum.TotalPrice]: priceNet,
    },
  };
};

export default updatePriceInBookingSteps;
